import { FOLLOWING_USER, UNFOLLOWING_USER } from '../actions/constants/users'

const followsReducer = (state = {}, action) => {
  switch (action.type) {
    case FOLLOWING_USER:
      return {
        ...state,
        [action.userID]: true
      }
    case UNFOLLOWING_USER:
      return {
        ...state,
        [action.userID]: false
      }
    default:
      return state
  }
}

export default followsReducer
